import moment from 'moment';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';
import frenchMessages from 'ra-language-french';
import { resolveBrowserLocale } from 'react-admin';
import customI18nMessages from '@/i18n';

export const DEFAULT_BROWSER_LOCALE = 'fr';

const i18nProvider = polyglotI18nProvider(
    (locale) => {
        const messages: any = {
            fr: {
                ...frenchMessages,
                ...customI18nMessages.fr,
            },
            en: {
                ...englishMessages,
                ...customI18nMessages.en,
            },
        };

        const finalLocale: string = locale in messages ? locale : 'fr';

        moment.locale(finalLocale);

        return messages[finalLocale];
    },
    resolveBrowserLocale(DEFAULT_BROWSER_LOCALE),
    [
        { locale: 'en', name: 'English' },
        { locale: 'fr', name: 'Français' },
    ],
);

export default i18nProvider;
